import { useCallback } from 'react';

import { useTranslate } from '@dreryk/react-common';

import { medicineTranslationKeys } from '~libs.desktop.shared.medicine';

import { AdministrationIntervalDays } from '../../extendedDosage.utils';

export const useAdministrationIntervalLabelExtractor = (): ((days: AdministrationIntervalDays) => string) => {
   const translate = useTranslate();

   return useCallback(
      (days: AdministrationIntervalDays): string =>
         translate(medicineTranslationKeys.extendedDosage.administrationIntervalMap[days]),
      [translate]
   );
};
